import { useMemo } from 'react';
import { isSameDay, isTomorrow, isWeekend } from 'date-fns';

const LAST_WEEK_DAY_INDEX = 6;

interface UseDayColumnParams {
  date: Date;
  dayIndex: number;
  onNavigateByDay?: (direction: 'prev' | 'next') => void;
}

export const useDayColumn = ({ date, dayIndex, onNavigateByDay }: UseDayColumnParams) => {
  return useMemo(
    () => ({
      isToday: isSameDay(date, new Date()),
      isTomorrowDate: isTomorrow(date),
      isWeekendDay: isWeekend(date),
      showLeftArrow: dayIndex === 0 && Boolean(onNavigateByDay),
      showRightArrow: dayIndex === LAST_WEEK_DAY_INDEX && Boolean(onNavigateByDay),
    }),
    [date, dayIndex, onNavigateByDay],
  );
};
